module.exports = __webpack_public_path__ + "static/media/cargorx-icon.f73d5e4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/cargorx-icon.png
// module id = 1634
// module chunks = 0